var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIbmLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "IBM_logo_8-bar_blue",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1075px",
    height: "401.15px",
    viewBox: "0 0 1075 401.15",
    enableBackground: "new 0 0 1000 401.15",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo International Business Machines Corporation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IBM_logo",
    fill: "#1f70c1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "I"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 373.17,
    width: 194.43,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    y: 319.83,
    width: 194.43,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.468,
    y: 266.54,
    width: 83.399,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.468,
    y: 213.25,
    width: 83.399,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.468,
    y: 159.96,
    width: 83.399,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55.468,
    y: 106.58,
    width: 83.399,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    y: 53.288,
    width: 194.43,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    width: 194.43,
    height: 27.932
  })), /*#__PURE__*/React.createElement("g", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m222.17 400.85 207.11 0.297c27.734 0 52.793-10.697 71.513-27.932h-278.62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m222.17 347.76h299.03c5.051-8.617 8.815-18.027 11.094-27.932h-310.12z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.73,
    y: 266.54,
    width: 83.3,
    height: 27.932
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.43 266.54v27.932h90.927c0-9.608-1.288-19.017-3.764-27.932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m497.92 213.25h-220.19v27.932h243.46c-6.34-10.698-14.165-20.107-23.277-27.932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m277.73 159.96v27.932h220.19c9.311-7.825 17.135-17.235 23.277-27.932z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.73,
    y: 106.58,
    width: 83.3,
    height: 27.932
  }), /*#__PURE__*/React.createElement("path", {
    d: "m444.43 134.51h87.163c2.476-8.914 3.764-18.324 3.764-27.932h-90.927z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m521.2 53.288h-299.03v27.932h310.12c-2.575-9.905-6.339-19.314-11.093-27.932z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m429.28 0h-207.11v27.932h278.53c-18.621-17.235-43.878-27.932-71.414-27.932z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "M"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "555.57 81.22 742.67 81.22 733.06 53.288 555.57 53.288"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "555.57 27.932 724.25 27.932 714.64 0 555.57 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "861.03 401.17 861.03 373.24 1e3 373.24 1e3 401.17",
    strokeWidth: 1.0018
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "861.03 347.76 861.03 319.83 1e3 319.83 1e3 347.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "777.73 182.54 769.91 159.96 694.43 159.96 611.03 159.96 611.03 187.89 694.43 187.89 694.43 162.24 703.25 187.89 852.22 187.89 861.03 162.24 861.03 187.89 944.43 187.89 944.43 159.96 861.03 159.96 785.56 159.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "944.43 106.58 803.98 106.58 794.37 134.51 944.43 134.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1e3 27.932 1e3 0 840.93 0 831.32 27.932"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "768.13 373.22 777.73 400.85 787.34 373.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "749.5 319.83 759.31 347.76 796.16 347.76 806.06 319.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "730.78 266.54 740.59 294.47 814.88 294.47 824.68 266.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "721.97 241.18 833.6 241.18 843.11 213.25 712.36 213.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.03 134.51 761.09 134.51 751.49 106.58 611.03 106.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1e3 53.288 822.4 53.288 812.9 81.22 1e3 81.22"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.57,
    y: 373.22,
    width: 138.97,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 555.57,
    y: 319.83,
    width: 138.97,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.03,
    y: 266.54,
    width: 83.399,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.03,
    y: 213.25,
    width: 83.399,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 861.03,
    y: 213.25,
    width: 83.399,
    height: 27.932
  }), /*#__PURE__*/React.createElement("rect", {
    x: 861.03,
    y: 266.54,
    width: 83.399,
    height: 27.932
  })), /*#__PURE__*/React.createElement("path", {
    id: "Registered",
    d: "m1052 357.15a22 22 0 0 0-22 22 22 22 0 0 0 22 22 22 22 0 0 0 22-22 22 22 0 0 0-22-22zm0 4a18 18 0 0 1 18 18 18 18 0 0 1-18 18 18 18 0 0 1-18-18 18 18 0 0 1 18-18zm-9.3476 6.793v22.414h5.453v-7.7305h3.0978l4.164 7.7305h5.9804l-5.0234-8.582c2.4616-0.96446 4.0624-3.2158 4.0624-6.75 0-4.0818-2.5594-7.082-7.582-7.082zm5.453 4.2891h4.0548c1.7114 0 2.668 0.75016 2.668 2.3555v1.6133c0 1.6053-0.9566 2.3594-2.668 2.3594h-4.0548z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIbmLogo);
export default __webpack_public_path__ + "static/media/IBM_logo.494a3c84bb8d49ae9137c0373e65ab28.svg";
export { ForwardRef as ReactComponent };